import React from 'react';
import PropTypes from 'prop-types';

import { factory } from '../positions/asset-position-details/asset-position-details-container';

import AssetPositionDetails from '../positions/asset-position-details/asset-position-details';

function LoansAssetPositionDetails(props) {
  return (<AssetPositionDetails
    {...props}
    renderBottomSeparator={true}
    row={Object.assign({}, props.row, {
      accruedInterestUnit: props.referenceCurrency,
      maturityInterestUnit: props.referenceCurrency,
      maturityInterestPandIUnit: props.referenceCurrency,
    })}
  />);
}

LoansAssetPositionDetails.propTypes = {
  row: PropTypes.object,
  referenceCurrency: PropTypes.string,
};

export default factory({
  component: LoansAssetPositionDetails,
  rowFragmentOmit: ['priceHistory'],

  rowFragmentExtend: {
    accruedInterest: true,
    amount: true,
    maturityDate: true,
    maturityInterest: true,
    maturityInterestPandI: true,
    maturityInterestPandIPosCcy: true,
    maturityInterestPosCcy: true,
  },
  mapperExtend: ({ currency }) => ({
    maturityInterestPandIPosCcyUnit: currency,
    maturityInterestPosCcyUnit: currency,
  }),
});

